import React from 'react'
import ReactDOM from 'react-dom'
import { CustomerModal, CustomerModalProps } from '@vend/business-components'
import { reactular } from '@vendhq/reactular'

const CustomerModalWrapper: React.FC<{ options: CustomerModalProps }> = ({
  options,
}) => {
  return ReactDOM.createPortal(<CustomerModal {...options} />, document.body)
}

export const reactCustomerModal = reactular(
  CustomerModalWrapper,
  ['options'],
  'reactWrapper'
)
